export default "__VITE_ASSET__CafGeviX__"